/* ChewCheer theme behaviour. No framework, no build step — this file ships as-is.
   Every widget is looked up by data attribute and skipped if absent, so sections
   can be removed in the customiser without breaking the rest of the page. */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------- mobile nav */
  var burger = $("[data-burger]");
  var mobileNav = $("#cc-mobile-nav");
  if (burger && mobileNav) {
    burger.addEventListener("click", function () {
      var open = burger.getAttribute("aria-expanded") === "true";
      burger.setAttribute("aria-expanded", String(!open));
      burger.setAttribute("aria-label", open ? "Open menu" : "Close menu");
      mobileNav.hidden = open;
      burger.classList.toggle("is-open", !open);
    });
  }

  /* ------------------------------------------------------------ gallery */
  $$("[data-gallery]").forEach(function (gallery) {
    var main = $("[data-gallery-main]", gallery);
    var thumbs = $$("[data-gallery-thumb]", gallery);
    if (!main || !thumbs.length) return;
    var index = 0;

    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      var src = thumbs[index].getAttribute("data-src");
      if (src) {
        main.src = src;
        main.removeAttribute("srcset");
      }
      thumbs.forEach(function (t, n) {
        t.classList.toggle("is-active", n === index);
        t.setAttribute("aria-pressed", String(n === index));
      });
    }

    thumbs.forEach(function (t, n) { t.addEventListener("click", function () { show(n); }); });
    var prev = $("[data-gallery-prev]", gallery);
    var next = $("[data-gallery-next]", gallery);
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
  });

  /* ------------------------------------------------- buy box: qty + variants */
  $$(".cc-buybox").forEach(function (box) {
    var qty = $("[data-qty]", box);
    var perPack = parseInt(box.getAttribute("data-chews-per"), 10) || 60;

    function syncNote() {
      if (!qty) return;
      var n = Math.max(1, parseInt(qty.value, 10) || 1);
      var packs = $("[data-packs]", box);
      var chews = $("[data-chews]", box);
      if (packs) packs.textContent = String(n);
      if (chews) chews.textContent = String(n * perPack);
      $$("[data-step]", box).forEach(function (b) {
        var dir = parseInt(b.getAttribute("data-step"), 10);
        var min = parseInt(qty.min, 10) || 1;
        var max = parseInt(qty.max, 10) || Infinity;
        b.disabled = dir < 0 ? n <= min : n >= max;
      });
    }

    $$("[data-step]", box).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qty) return;
        var dir = parseInt(btn.getAttribute("data-step"), 10);
        var min = parseInt(qty.min, 10) || 1;
        var max = parseInt(qty.max, 10) || Infinity;
        var next = (parseInt(qty.value, 10) || 1) + dir;
        qty.value = String(Math.min(max, Math.max(min, next)));
        syncNote();
      });
    });
    if (qty) qty.addEventListener("change", syncNote);
    syncNote();

    // Variant picker: match the selected option values against the variant list.
    var dataEl = $("[data-variants]", box);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = $$("[data-option-index]", box);
    var idField = $("[data-variant-id]", box);
    var addBtn = $("[data-add]", box);
    var addText = $("[data-add-text]", box);
    var priceEl = $("[data-price]", box);
    var compareEl = $("[data-compare]", box);

    function pick() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];

      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = "Unavailable";
        return;
      }
      if (idField) idField.value = String(match.id);
      if (addBtn) addBtn.disabled = !match.available;
      if (addText) addText.textContent = match.available ? "Pre-Order" : "Sold out";
      if (priceEl) priceEl.textContent = match.price_formatted;
      if (compareEl) {
        var hasCompare = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = match.compare_at_price_formatted;
      }
    }

    selects.forEach(function (s) { s.addEventListener("change", pick); });
    pick();
  });

  /* --------------------------------------------------------------- tabs */
  $$("[data-tabs]").forEach(function (root) {
    var tabs = $$(".cc-tabs__tab", root);
    var panels = $$(".cc-tabs__panel", root);
    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t, n) {
          t.classList.toggle("is-active", n === i);
          t.setAttribute("aria-selected", String(n === i));
        });
        panels.forEach(function (p, n) { p.hidden = n !== i; });
      });
    });
  });

  /* ---------------------------------------------------------------- faq */
  $$("[data-faq]").forEach(function (root) {
    var buttons = $$(".cc-faq__q", root);
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var open = btn.getAttribute("aria-expanded") === "true";
        buttons.forEach(function (other) {
          other.setAttribute("aria-expanded", "false");
          var panel = document.getElementById(other.getAttribute("aria-controls"));
          if (panel) panel.hidden = true;
        });
        if (!open) {
          btn.setAttribute("aria-expanded", "true");
          var panel = document.getElementById(btn.getAttribute("aria-controls"));
          if (panel) panel.hidden = false;
        }
      });
    });
  });

  /* --------------------------------------------------------------- milo */
  var miloForm = $("[data-milo-form]");
  if (miloForm) {
    var input = $("input", miloForm);
    $$("[data-milo-prompts] button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!input) return;
        input.value = btn.textContent.trim();
        input.focus();
      });
    });
  }
})();
